<template>
  <div class="sidebar sidebar-doom-yoga">
    <div class="user" style="z-index: 3">
      <div class="photo photo-full text-center mb-3">
        <img
          src="@/assets/images/doom-yoga/Doomyoga-logo.png"
          id="adminNavLogoImg"
        />
      </div>
    </div>
    <div class="sidebar-wrapper">
      <ul class="nav">
        <li class="nav-item">
          <router-link to="/doom_yoga/dashboard" class="nav-link d-flex">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/doom-yoga/dashboard-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/doom-yoga/dashboard-icon-red.png"
              alt=""
            />
            <p>Dashboard</p></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/doom_yoga/my_studio" class="nav-link d-flex">
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/doom-yoga/my-studio-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/doom-yoga/my-studio-icon-red.png"
              alt=""
            />
            <p>My Studio</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/doom_yoga/customers" class="nav-link d-flex">
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/doom-yoga/customers-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/doom-yoga/customers-icon-red.png"
              alt=""
            />
            <p>Customers</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/doom_yoga/marketing" class="nav-link d-flex">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/doom-yoga/marketing-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/doom-yoga/marketing-icon-red.png"
              alt=""
            />
            <p>Marketing</p></router-link
          >
        </li>
        <li class="nav-item">
          <a class="nav-link d-flex"  href="" @click="logout">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/doom-yoga/logout-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/doom-yoga/logout-icon-red.png"
              alt=""
            />
            <p>Logout</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarDoomYoga",
  data() {
    return {};
  },
  methods: {
    logout() {
      console.log("logoutt doom yoga admin");
      //  console.log(this.$children)
      // this.$confirm({
      //   title: 'Are you sure?',
      //   message: 'Are you sure you want to logout?',
      //   button: {
      //     yes: 'Yes',
      //     no: 'Cancel'
      //   },
      //   callback: confirm => {
      //     if (confirm) {
      localStorage.removeItem("user");
      localStorage.removeItem("customer");
      localStorage.removeItem("spotify_access_token")
      localStorage.removeItem("spotify_refresh_token")
      localStorage.removeItem("spotify_token_timestamp")
      //  App.isLogin = false;
      this.$router
        .go({ name: "DoOmYogaLogin", params: { type: "admin" } })
        .catch(() => {});
      // console.log(localStorage);
      //     }
      //   }
      // })
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/partials/admin_sidebar_doom_yoga.vue